import { render, staticRenderFns } from "./LayoutTabs.vue?vue&type=template&id=321bf508&scoped=true&"
var script = {}
import style0 from "./LayoutTabs.vue?vue&type=style&index=0&id=321bf508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321bf508",
  null
  
)

export default component.exports